const companyLinksFooter = [
    { name: "Home", url: "/" },
    { name: "Insurances", url: "/insurances" },
    { name: "Medicare Hospice", url: "/medicare-hospice" },
    { name: "F.A.Q.", url: "/faq" },
    { name: "About", url: "/about" },
    { name: "Privacy Policy", url: "/privacy-policy" },
    { name: "Term and Conditions", url: "/term-and-conditions" },
    { name: "Contact", url: "/contact" },
    { name: "Helpful Articles", url: "/helpful-articles" },
    { name: "Referrals", url: "/referrals" },
    { name: "Site Map", url: "/sitemap.xml", external: true }
];

export default companyLinksFooter;